import {createSelector} from 'reselect';

import {AppState} from '../../../store';

export const srpSelector = (state: AppState) => state.srp;
export const srpStateSelector = createSelector(srpSelector, item => item);
export const journeyTypeSelector = createSelector(srpSelector, item => item.journeyType);
export const dataLoadingSelector_0 = createSelector(srpSelector, item => item.dataLoading);

//TODO:- use single entry point instead of state.srp.
export const dataLoadingSelector = (state:AppState)=> {
  return state.srp.dataLoading
  }


export const srpPrivateBusesSelector = (state: AppState) => {
  return {
    privateAvailableBuses: state.srp.privateAvailableBuses,
    privateSoldOutBuses: state.srp.privateSoldOutBuses,
  };
};

export const srpRTCBusesSelector = (state: AppState) => {
  return {
    rtcBuses: state.srp.rtcBuses,
  };
};
export const srpRTCViewSelector = (state: AppState) => {
  return {
    rtcView: state.srp.rtcView,
  };
};

export const srpRawDataSelector = (state: AppState) => {
  return {rawData: state.srp.rawData};
};
export const sortBySelector = (state: AppState) => {
  return {sortBy: state.srp.sortBy};
};

export const srpFiltersSelector = (state: AppState) => {
  return {filters: state.srp.filters};
};

export const srpSelectedFiltersSelector = (state: AppState)=>{
return {selectedFilters: state.srp.selectedFilters}
}
export const srpSelectedBusIdsSelector = (state:AppState)=>{
  return state.srp.selectedBusIds;
}
export const srpGoSafeBannerSelector =(state:AppState)=>{
  return state.srp.goSafeData;
}

export const srpRouteIdSelector =(state:AppState)=>{
  return state.srp.routeId;
}
export const routeEnableSelector=(state:AppState)=>{
  return state.srp.isRouteEnable;
}
export const persuationDataSelector=(state:AppState)=>{
  return state.srp.ps;
}
export const alternateRouteSelector=(state:AppState)=>{
  return state.srp.alternate_route_data;
}
export const nextDayBusSelector=(state:AppState)=>{

  return state.srp.next_day_bus;
}

export const moveToAlternateRoutePageSelector =(state:AppState)=>{
  return state.srp.moveToAlternateRoutePage;
}
export const nextDayPopupSelector =(state:AppState)=>{
  return state.srp.nextDayPopup;
}
export const srpCardIndex =(state:AppState)=>{
  return state.srp.srpCardIndex;
}
export const srpFilterCardsSelector =(state:AppState)=>{
  return state.srp.filter_cards;
}